import { render, staticRenderFns } from "./PersonDialogComponent.vue?vue&type=template&id=6e7f55aa&scoped=true"
import script from "./PersonDialogComponent.js?vue&type=script&lang=js&external"
export * from "./PersonDialogComponent.js?vue&type=script&lang=js&external"
import style0 from "./PersonDialogComponent.vue?vue&type=style&index=0&id=6e7f55aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7f55aa",
  null
  
)

export default component.exports